import React from 'react'
import { Col, Row } from 'react-bootstrap'
import BadgeCardAncla from './BadgeCardAncla'

const ElectronicaList = () =>{
    return(
        <>
            <div className = "container my-5">
                <div className = " text-center">
                    <h1>Electrónica</h1>
                    <p>Proyectos que implican hardware</p>
                </div>
                <Row  xs={1} md={3} className="g-4">
                    <Col>
                        <BadgeCardAncla  badgeColor = "bg-warning" title = "Sistema de riego" p = "Sistema automático de regado de plantas" Link = "https://github.com/llFREEDll/irrigation-system"/>
                    </Col>
                    <Col>
                    <BadgeCardAncla  badgeColor = "bg-dark" title = "Seguidor de líneas" p = "Robot autónomo capaz de seguir líneas negras" Link = "https://github.com/llFREEDll/LineFollower"/>
                    </Col>
                    <Col>
                    <BadgeCardAncla  badgeColor = "bg-info" title = "Calculadora con pic" p = "Una calculadora diseñada con hardware" Link = "https://github.com/llFREEDll/float-calculator-pic16f877A"/>
                    </Col>
                </Row>    
            </div>
        </>
    )
}

export default ElectronicaList